import React from "react";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import { desktop, tablet } from "utils";

export const Nav = ({ setMobileMenuOpen }) => {
  const matchesTablet = useMediaQuery(tablet);
  const matchesDesktop = useMediaQuery(desktop);

  const nav = [
    {
      title: "Sužinok daugiau",
      link: "#SužinokDaugiau",
    },
    {
      title: "Patarimai",
      link: "#Patarimai",
    },
  ];

  return (
    <Stack direction={matchesTablet ? "column" : "row"} spacing={8}>
      {nav.map(({ title, link }) => (
        <a href={link} onClick={() => matchesTablet && setMobileMenuOpen(false)} key={title}>
          <Typography
            variant="body1"
            color={matchesDesktop ? "primary" : "primary.contrastText"}
            sx={{
              cursor: "pointer",
            }}
          >
            {title}
          </Typography>
        </a>
      ))}
    </Stack>
  );
};
